import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Site } from '../../../../../../../models/site';
import { SiteService } from '../../../../../../../services/site.service';
import { Helpers } from '../../../../../../../helpers';
import { BaseComponent } from '../../../../base.component';
import { PublisherDetailTab } from '../../../../owner/publisher-detail/publisher-detail.component';
import { DataService } from '../../../../../../../_services/data.service';
import { Paths } from '../../../../../../../models/enums';

@Component({
    selector: 'app-site',
    templateUrl: './update-site.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UpdateSiteComponent extends BaseComponent implements OnInit {
    site: Site = new Site();
    returnUrl: string;
    publisherName: string;

    constructor(
        private siteService: SiteService,
        private router: Router,
        private dataService: DataService,
        route: ActivatedRoute
    ) {
        super();
        this.site.id = route.snapshot.params.id;
        this.returnUrl = route.snapshot.queryParams.returnUrl;
        this.publisherName = route.snapshot.queryParams.publisherName;
        this.buildBreadcrumb(route);
    }

    buildBreadcrumb(route) {
        route.snapshot.parent.data.url = '/' + this.returnUrl;
        if (this.dataService.path == Paths.Owner) {
            route.snapshot.parent.data.breadcrumb = this.publisherName;
            route.snapshot.parent.data.queryParams = { name: this.publisherName };
        }
    }

    ngOnInit() {
        this.getSite();
    }

    getSite() {
        Helpers.setLoading(true);
        this.siteService.find(this.site.id).subscribe(res => {
            this.site = res.data;
            Helpers.setLoading(false);
        });
    }

    navigate() {
        let queryParams = { siteId: this.site.id };
        if (this.dataService.path == Paths.Owner) {
            queryParams['tab'] = PublisherDetailTab.Inventory;
            queryParams['name'] = this.publisherName;
        }
        this.router.navigate([this.returnUrl], {
            queryParams: queryParams
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                title: customRules.requiredText
            }
        });
    }

    updateSite() {
        var _self = this;
        Helpers.setLoading(true);
        this.siteService.update(_self.site).subscribe(() => {
            Helpers.setLoading(false);
            this.swalService.successUpdate();
            setTimeout(function() {
                _self.navigate();
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/site/update-site/update-site.component.ts